import { create } from 'zustand';

interface DocumentsPageStore {
  addOpen: boolean;
  editTarget: unknown | null;
  deleteConfirm: string | null;
  deleteError: string | null;
  setAddOpen: (open: boolean) => void;
  setEditTarget: (t: unknown | null) => void;
  setDeleteConfirm: (id: string | null) => void;
  setDeleteError: (e: string | null) => void;
}

export const useDocumentsPageStore = create<DocumentsPageStore>((set) => ({
  addOpen: false,
  editTarget: null,
  deleteConfirm: null,
  deleteError: null,
  setAddOpen: (open) => set({ addOpen: open }),
  setEditTarget: (t) => set({ editTarget: t }),
  setDeleteConfirm: (id) => set({ deleteConfirm: id }),
  setDeleteError: (e) => set({ deleteError: e }),
}));
